type IdentityCarrier = {
  nationalId?: string;
  businessID?: string;
  isPrivatePerson?: boolean;
} | null;

export const getIsPrivatePerson = (user?: IdentityCarrier) =>
  user?.isPrivatePerson !== false;

export const getUserIdentifier = (user?: IdentityCarrier) =>
  getIsPrivatePerson(user)
    ? String(user?.nationalId || "").trim()
    : String(user?.businessID || "").trim();

export const getUserIdentifierLabel = (user?: IdentityCarrier) =>
  getIsPrivatePerson(user) ? "کد ملی" : "شناسه ملی";

export const getUserPersonTypeLabel = (user?: IdentityCarrier) =>
  getIsPrivatePerson(user) ? "شخص حقیقی" : "شخص حقوقی";
